const PVKEEP_EXTRA_PARAMS = 'PVKEEP_EXTRA_PARAMS';
// PC端埋点JS接入方案 http://docs.stream.jd.com/sdk_manual/pc_sdk/#133

function getExtraParams() {
  let extraParams = '';
  try {
    extraParams = window.sessionStorage.getItem(PVKEEP_EXTRA_PARAMS) || '{}';
  } catch (ex) {
    // eslint-disable-next-line
    console.error(ex)
  }
  return extraParams;
}

function getInterval(fn, interval) {
  let timeoutId = null;

  function itervalFun() {
    timeoutId = setTimeout(() => {
      itervalFun();
      fn();
    }, interval);
  }

  itervalFun();

  function clearInterval() {
    timeoutId && clearTimeout(timeoutId);

    timeoutId = null;
  }
  return clearInterval;
}

// 通过参数通知外部开始监听或失活
function getMouseTrigger(onStartReport, onStopReport) {
  let positionXY = '';
  document.addEventListener('mousemove', function (ev) {
    positionXY = `${ev.clientX};${ev.clientY}`;
  });

  let conditionPositionXY = '';
  let cleanInterval = null;

  // 通知页面开始监听click事件，20s之后失活
  function startReport() {
    if (cleanInterval) return;
    conditionPositionXY = positionXY;
    document.body.removeEventListener('click', startReport);
    cleanInterval?.();
    cleanInterval = getInterval(() => {
      if (conditionPositionXY === positionXY) {
        // eslint-disable-next-line
        stopReport()
      } else {
        conditionPositionXY = positionXY;
      }
    }, 20 * 1000);
    onStartReport();
    window.aaa = () => cleanInterval;
  }

  function stopReport() {
    document.body.removeEventListener('click', startReport);
    document.body.addEventListener('click', startReport);
    cleanInterval?.();
    cleanInterval = null;
    onStopReport();
  }

  // 外部通知内部开始监听或失活
  return {
    startReport,
    stopReport,
  };
}

export function stayOnReport(store, params = {}) {
  const timer = params.timer || 5 * 1000; // 默认为每5s做一次合计，判断是否上报
  const log_type_id1 = params.log_type_id1 || 'yx_center';
  const log_type_id2 = params.log_type_id2 || 'Pvkeep';
  let href = window.location.href;
  let erp = 'unknow';
  // const event_param = params.event_param || [href]
  // 当前页面是否失焦
  let onblur = !document.hasFocus();
  // 每轮计时开始时间
  let roundStartTime = +new Date();

  store.subscribe(function () {
    const allState = store.getState();
    const userErp = allState.userInfo.userMap && allState.userInfo.userMap.erp;
    if (userErp === erp) return;
    erp = userErp;
  });

  function report(forceReport = false) {
    // 非失焦状态 或 强制执行 时，进行上报
    if (!onblur || forceReport) {
      // 上报活跃埋点
      window.log && window.log(log_type_id1, log_type_id2, getExtraParams());
    }

    // 重置时间
    roundStartTime = +new Date();
  }

  // 每次调用stayOnReport都会生成一个维护定时器状态的对象
  const singleReport = {
    stayOnReportInterval: null,
    shouldReport: true,
    clear() {
      // 如果当前定时器已经被清空返回
      if (!this.stayOnReportInterval) return;
      if (this.stayOnReportInterval) {
        clearInterval(this.stayOnReportInterval);
        // 清空计数器，并重置统计状态
        this.stayOnReportInterval = null;
      }
      // 当前这轮监听的时长
      const roundTimeInterval = Number(+new Date()) - Number(roundStartTime);
      if (roundTimeInterval >= timer / 2) {
        // 如果此轮监听时长超过一轮的一半，即2.5s，则进行一次上报
        report(true);
      }
    },
    setShouldReport(status) {
      this.shouldReport = status;
    },
  };

  const mouseTrigger = getMouseTrigger(
    () => {
      if (!singleReport.stayOnReportInterval && singleReport.shouldReport) {
        singleReport.stayOnReportInterval = setInterval(function () {
          report();
        }, timer);
      }
      onblur = false;
    },
    () => {
      onblur = true;
      singleReport.clear();
    }
  );

  // 监听页面失焦事件
  window.addEventListener('blur', () => {
    singleReport.clear();
    mouseTrigger.stopReport();

    // 记录为失焦状态
    onblur = true;
  });

  /**
   * 监听页面聚焦事件
   */
  window.addEventListener('focus', () => {
    if (!singleReport.stayOnReportInterval && singleReport.shouldReport) {
      singleReport.stayOnReportInterval = setInterval(function () {
        report();
      }, timer);
      mouseTrigger.startReport();
    }
    onblur = false;
  });

  /**
   * 当不存在计时器时，进行生成
   */
  if (!singleReport.stayOnReportInterval && !onblur) {
    /**
     * 初始化时计时器开始
     * @type {NodeJS.Timeout}
     * @private
     */
    singleReport.stayOnReportInterval = setInterval(function () {
      report();
    }, timer);

    mouseTrigger.startReport();
  }
  return singleReport;
}
